import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

// react-router-dom components
import { Link } from 'react-router-dom';

// @mui material components
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';
import SoftButton from 'components/SoftButton';

// Authentication layout components
import IllustrationLayout from 'layouts/authentication/components/IllustrationLayout';

// Imagen para el layout
import logo from 'assets/images/logos/new_logo.png';
import backgroundImage1 from 'assets/images/login/login-1.png';
import backgroundImage3 from 'assets/images/login/login-4.jpeg';
import backgroundImage4 from 'assets/images/login/login-5.jpeg';

// Context para la autenticación
import { AuthContext } from 'context/AuthContext';

function Illustration() {
  const [rememberMe, setRememberMe] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  // Verifica si ya existe un token y redirige a /ordenes
  useEffect(() => {
    if (Cookies.get('access_token')) {
      navigate('/ordenes', { replace: true });
    }
  }, [navigate]);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true); // Inicia la carga

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/token/`,
        { username, password },
        { withCredentials: true }
      );

      // Aquí podrías guardar el token si lo recibes en la respuesta
      // Cookies.set('token', response.data.token);

      await login(); // esperar a que la verificación termine (isAuthenticated=true)
      navigate('/ordenes', { replace: true });
    } catch (err) {
      setError('Nombre de usuario o contraseña incorrectos');
    } finally {
      setIsLoading(false); // Finaliza la carga, ya sea en éxito o error
    }
 };

  return (
    <IllustrationLayout
      topImage={logo}
      color="white"
      description="Ordenes - Logistica - Finanzas"
      illustration={{
        images: [backgroundImage1, backgroundImage3, backgroundImage4],
        description: '',
      }}
    >
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2} lineHeight={1.25}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Usuario
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
        </SoftBox>
        <SoftBox mb={2} lineHeight={1.25}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Contraseña
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </SoftBox>
        {error && (
          <SoftTypography color="error" variant="caption">
            {error}
          </SoftTypography>
        )}
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: 'pointer', userSelect: 'none' }}
          >
            &nbsp;&nbsp;Recordar
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            type="submit"
            variant="gradient"
            color="info"
            fullWidth
            disabled={isLoading} // Se deshabilita el botón mientras se inicia la sesión
          >
            {isLoading ? 'Entrando a CargoSys...' : 'Entrar'}
          </SoftButton>
        </SoftBox>
      </SoftBox>

      {/* Footer con iconos de redes sociales */}
      <SoftBox mt={3} textAlign="center">
        <SoftBox display="flex" justifyContent="center">
          <IconButton
            aria-label="Instagram"
            href="https://www.instagram.com/cargonautscl"
            target="_blank"
          >
            <InstagramIcon fontSize="large" />
          </IconButton>
          <IconButton
            aria-label="LinkedIn"
            href="https://www.linkedin.com/company/cargonauts"
            target="_blank"
          >
            <LinkedInIcon fontSize="large" />
          </IconButton>
        </SoftBox>
      </SoftBox>
    </IllustrationLayout>
  );
}

export default Illustration;
